import { render, staticRenderFns } from "./partdiff.vue?vue&type=template&id=74237376&scoped=true&"
import script from "./partdiff.vue?vue&type=script&lang=js&"
export * from "./partdiff.vue?vue&type=script&lang=js&"
import style0 from "./partdiff.vue?vue&type=style&index=0&id=74237376&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74237376",
  null
  
)

export default component.exports